<template>
  <div class="v2-currently-on-site">
    <span class="bg-sticker star-nude">
      <img v-lazy="starNudeLightSticker" :alt="`sticker star nude`" width="16" height="16" />
    </span>

    <span class="bg-sticker star-light-pink d-none d-md-inline-block">
      <img v-lazy="starPinkLightSticker" :alt="`sticker star`" width="240" height="24" />
    </span>

    <span class="bg-sticker star-mint-large">
      <img v-lazy="starMintLightSticker" :alt="`sticker star`" width="32" height="32" />
    </span>

    <h2 id="currently-on-ersties" class="mb-0 text-center">
      {{ t("Currently on Ersties") }}
    </h2>

    <div v-if="!video" class="video">
      <div class="player">
        <currently-on-ersties-video-placeholder />
      </div>
      <currently-on-ersties-text-placeholder />
    </div>
    <div v-else class="video">
      <div class="player">
        <app-frame>
          <lazy-player id="currently-on-site-video" :video="video" :poster="getFreeareaVideoPoster(video.thumb)" />
        </app-frame>
      </div>
      <div class="row">
        <div class="col-md-5">
          <h3 class="mb-2">
            {{ video[`title_${locale}`] }}
          </h3>
          <div class="d-none d-md-flex justify-content-center justify-content-md-start mt-5">
            <button v-modal.modal-signup class="btn btn-primary wide" @click="sendRegistrationTrack">
              {{ t("Watch Now") }}
            </button>
          </div>
        </div>
        <div class="col-md-7 ms-auto">
          <div class="description">
            {{ video[`current_description_${locale}`] }}
          </div>
          <div class="d-flex d-md-none justify-content-center justify-content-md-start mt-4">
            <button v-modal.modal-signup class="btn btn-primary wide" @click="sendRegistrationTrack">
              {{ t("Watch Now") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from "vue";
import { useI18n } from "vue-i18n";
import CurrentlyOnErstiesTextPlaceholder from "@/components/v2/placeholders/currently-on-ersties-text-placeholder/index.vue";
import CurrentlyOnErstiesVideoPlaceholder from "@/components/v2/placeholders/currently-on-ersties-video-placeholder/index.vue";
import AppFrame from "@/components/v2/app-frame/index.vue";
import { amplitudeRegistrationButtonClickTrack } from "@/utils/amplitude";
import { FreeareaVideo } from "@/interfaces/Video/FreeareaVideo.ts";
import starNudeLightSticker from "@/assets/v2/images/stickers/star-nude-light.svg";
import starPinkLightSticker from "@/assets/v2/images/stickers/star-pink-light.svg";
import starMintLightSticker from "@/assets/v2/images/stickers/star-mint-light.svg";
import LazyPlayer from "@/components/lazy-player/index.vue";
import { getFreeareaVideoPoster } from "@/utils/mediaHelper.ts";

defineOptions({
  name: "currently-on-site",
});

defineProps({
  video: {
    type: Object as PropType<FreeareaVideo>,
    required: true,
  },
});

const { locale, t } = useI18n();

const sendRegistrationTrack = () => {
  amplitudeRegistrationButtonClickTrack("currently on site");
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
